import { Link } from 'react-router-dom';
import { Styles } from '@gv/triage-components';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
`;

export const Divider = styled.div<{ isDarkTheme: boolean }>`
  width: 1px;
  background-color: ${({ isDarkTheme }) =>
    isDarkTheme ? '#F9F9F9' : '#202020'};
  margin: 12px 0;
`;

export const MainButton = styled(Link)<{
  $hasAction: boolean;
  $isComingSoon: boolean;
}>`
  gap: 8px;
  display: flex;
  cursor: pointer;
  padding: 16px 24px;
  position: relative;
  align-items: center;
  flex: 1;
  ${({ theme, $hasAction, $isComingSoon }) => css`
    color: ${theme.config.text.primary} !important;

    svg {
      width: 32px;
      height: 32px;

      path {
        fill: ${theme.config.text.primary};
      }
    }

    border: 1px solid ${theme.config.dasboardButtonPO.border};
    background-color: ${theme.config.dasboardButtonPO.background.default};

    ${$hasAction &&
    css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;
    `}

    ${$isComingSoon
      ? css`
          cursor: not-allowed;
          &:after {
            top: -8px;
            right: 16px;
            padding: 0 8px;
            font-size: 10px;
            line-height: 16px;
            position: absolute;
            border-radius: 8px;
            content: 'Coming soon';
            color: ${theme.config.text.inverse};
            background-color: ${theme.config.text.primary};
          }
        `
      : css`
          &:hover {
            background-color: ${theme.config.dasboardButtonPO.background.hover};
          }

          &:active {
            background-color: ${theme.config.dasboardButtonPO.background
              .action};
          }
        `}
  `};
`;

export const ActionButton = styled.button<{ $isComingSoon: boolean }>`
  display: flex;
  cursor: pointer;
  padding: 16px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.config.dasboardButtonPO.border};
  background-color: ${({ theme }) =>
    theme.config.dasboardButtonPO.background.default};
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  border-left: none;

  svg {
    width: 20px;
    height: 20px;

    path {
      fill: ${({ theme }) => theme.config.text.primary};
    }
  }

  ${({ theme, $isComingSoon }) => css`
    color: ${theme.config.text.primary} !important;

    ${$isComingSoon
      ? css`
          cursor: not-allowed;
          opacity: 0.5;
        `
      : css`
          &:hover {
            background-color: ${theme.config.dasboardButtonPO.background.hover};
          }

          &:active {
            background-color: ${theme.config.dasboardButtonPO.background
              .action};
          }
        `}
  `};
`;

export const Subtitle = styled.p`
  ${Styles.Font.ultraSmall};
  ${({ theme }) => css`
    color: ${theme.config.button.ghost.transparent.action.text};
  `}
`;
